import EnvFile from "./assets/env-local.json";

// Local dev: relative public path
// eslint-disable-next-line no-undef
__webpack_public_path__ = "/";

window.MLBBest = {
  envVariables: EnvFile,
};
